import api from "./api";

export const LIVE_TRACK_SEARCH_KEY = "fr.liveTracking.searchItem";

export function storeLiveTrackSearchItem(item) {
  try {
    sessionStorage.setItem(LIVE_TRACK_SEARCH_KEY, JSON.stringify(item || {}));
  } catch {
    /* ignore quota / private mode */
  }
}

export function readLiveTrackSearchItem() {
  try {
    const raw = sessionStorage.getItem(LIVE_TRACK_SEARCH_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export const fieldTrackingService = {
  getTraceStatuses: async (token) => {
    const res = await api.get("/field-tracking/trace-statuses", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  postLocation: async (caseId, payload, token) => {
    const res = await api.post(`/field-tracking/cases/${caseId}/location`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  resolveCase: async (payload, token) => {
    const res = await api.post("/field-tracking/cases/resolve", payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  /** App-wide live position for admin / team leader field map */
  postMyLocation: async (payload, token) => {
    const res = await api.post("/field-tracking/me/location", payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  patchTraceStatus: async (caseId, payload, token) => {
    const res = await api.patch(`/field-tracking/cases/${caseId}/trace-status`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getTimeline: async (caseId, token) => {
    const res = await api.get(`/field-tracking/cases/${caseId}/timeline`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  getLocations: async (caseId, token, params = {}) => {
    const res = await api.get(`/field-tracking/cases/${caseId}/locations`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { limit: 50, ...params },
    });
    return res.data;
  },

  getLiveTracers: async (token) => {
    const res = await api.get("/field-tracking/tracers/live", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },
};
